<template>

  <vx-card>

    <div class="vx-row">
      <div class="vx-col">
        <h5> {{ $t('course-outline-registration.info-title') }}</h5>
      </div>
    </div>

    <vs-divider/>


    <!-- Avatar -->
    <div class="vx-row">

      <!-- Avatar Col -->
      <div class="vx-col">
        <div class="img-container">
          <img class="rounded" width="130" height="130" :src="courseOutline ? getAvatarUrl(courseOutline.teacher.picturePath):''"/>
        </div>
      </div>

      <!-- Information - Col 1 -->
      <div class="vx-col flex-1">

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.teacher-code') }}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <span v-if="courseOutline">{{ courseOutline.teacher.code }}</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.teacher') }}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <span v-if="courseOutline">{{ courseOutline.teacher | teacherName }}</span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-semibold"> {{ $t('vdo-set.course-outline-unit-qty') }}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <span v-if="courseOutline">{{ courseOutline.courseOutlineUnits.length + ' ' + $t('vdo-set.unit')}}</span>
            <span v-else>-</span>
          </div>
        </div>

      </div>
      <!-- /Information - Col 1 -->

      <!-- Information - Col 2 -->
      <div class="vx-col flex-1">

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.subject-code') }}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <span v-if="courseOutline">{{ courseOutline.subject.code }}</span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.subject-name') }}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <span v-if="courseOutline">{{ courseOutline.subject.nameLocal }}</span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.credit') }}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <span v-if="courseOutline">{{ courseOutline.subject.creditCalGrade + ' (' + courseOutline.subject.creditDesc + ')'}}</span>
            <span v-else>-</span>
          </div>
        </div>
      </div>

    </div>

  </vx-card>

</template>

<script>
  import {state} from "../data";
  import {getAvatarUrl} from "@/utils/upload";

  export default {
    components: {},
    data() {
      return {
        local: state.local,
        getAvatarUrl: getAvatarUrl,
      }
    },
    computed: {
      courseOutline() {
        return this.local.vdoSetEdit.courseOutline;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//

      //---------------------------------------- Event Function ------------------------------------------------------//

      //---------------------------------------- Local Function ------------------------------------------------------//
    },
  }
</script>

<style scoped>

</style>
